var map = {
	"./Loading-Icon.gif": 1023,
	"./app-awareness-phone.png": 454,
	"./app-modal-android@2x.png": 455,
	"./app-modal-iphone@2x.png": 456,
	"./app-promo-banner-background.png": 1024,
	"./box-prices/2-portions.png": 1025,
	"./box-prices/2-portions.webp": 1026,
	"./box-prices/4-portions.png": 1027,
	"./box-prices/4-portions.webp": 1028,
	"./box-prices/best-value.png": 457,
	"./box-prices/box-prices-hero.jpg": 573,
	"./box-prices/couples-box.jpg": 1029,
	"./box-prices/family-box.jpg": 1030,
	"./box-prices/four-person-box.jpg": 452,
	"./box-prices/most-popular.png": 458,
	"./box-prices/two-person-box.jpg": 451,
	"./discount-modal-header.jpg": 459,
	"./earn-reward-background.jpg": 1031,
	"./five-recipes/five-recipes.png": 1032,
	"./gousto-boxes.jpg": 1033,
	"./gousto-welcome-journey-rollover.jpg": 1034,
	"./hungry-for-savings.png": 1035,
	"./menu/FebYouary_desktop.jpg": 1036,
	"./menu/FebYouary_mobile.jpg": 1037,
	"./menu/FebYouary_tablet.jpg": 1038,
	"./menu/default_desktop_no_click.png": 1039,
	"./menu/default_mobile_no_click.png": 1040,
	"./menu/default_tablet_no_click.png": 1041,
	"./menu/spottyTileBorder.png": 460,
	"./my-gousto-pricing-modal.svg": 1042,
	"./pause-osr-modal-bg.jpg": 1043,
	"./product-placeholder.png": 301,
	"./recipe-placeholder.png": 154,
	"./red-rice-pattern.png": 1044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 572;